import { useEffect } from 'react';

const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = 'ru';
  }, [title]);
};

export default useDocumentTitle;
